import type { RouteRecordRaw } from 'vue-router'

import { ROUTE_NAMES } from '~/constants/routes'

const routes = (): RouteRecordRaw[] => {
  return [
    {
      component: () =>
        import('~/scopes/customer-reviews/pages/CustomerReviews.vue'),
      name: ROUTE_NAMES.CUSTOMER_REVIEWS.INDEX,
      path: '/bo-seller/customer-reviews',
      meta: {
        owners: ['bot-squad-seller-experience-front'],
      },
    },
  ]
}

export default routes
